// SUB.4 — single source for how a trial tenant's ENTITLEMENTS resolve.
//
// During the trial a tenant gets the TOP tier's experience (pages, modules, and
// limits) until they buy a plan; on purchase they're pinned to what they bought.
// The stored tenants.plan stays 'trial' — only the *effective entitlement* plan is
// resolved here. Mirrors the SQL source public.get_trial_entitlement_plan().
export const TRIAL_ENTITLEMENT_PLAN = 'pro'

// Resolve a stored tenants.plan to the plan whose entitlements apply:
//   'trial'          -> TRIAL_ENTITLEMENT_PLAN (the top tier)
//   any real plan    -> itself (starter/growth/pro unchanged)
//   null / undefined -> passed through unchanged, so a genuinely-unknown plan keeps
//                       its existing fail-open behaviour downstream.
export function resolveEntitlementPlan(
  plan: string | null | undefined,
): string | null | undefined {
  return plan === 'trial' ? TRIAL_ENTITLEMENT_PLAN : plan
}
